// extracted by mini-css-extract-plugin
module.exports = {"menuList":"menuSection_menuList__3Y8Mq"};